import { darken } from '@mui/material';

import makeStyles from '../../utils/makeStyles';
import { FaqProps } from './Faq';

export default makeStyles<Pick<FaqProps, 'size'>>()((theme, { size }) => ({
  faqAccordion: {
    padding: 0,
    margin: 0,
    backgroundColor: 'transparent',
    position: 'relative',
    borderBottom: '.1rem solid #ddd',
    '&::before': {
      display: 'none',
    },
    '&:first-of-type': {
      borderTop: '.1rem solid #ddd',
    }
  },
  faqAccordionIcon: {
    height: 'auto',
    width: 24,
    fill: theme.palette.common.black,
  },
  faqQuestion: {
    color: theme.palette.common.black,
    fontSize: 14,
    fontWeight: 500,
    marginTop: size === 'small' ? theme.spacing(1) : theme.spacing(2),
    marginBottom: size === 'small' ? theme.spacing(1) : theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      fontSize: 18,
    }
  },
  faqAnswer: {
    fontSize: 13,
    lineHeight: 1.6,
    fontWeight: 'normal',
    marginBottom: theme.spacing(4),
    color: theme.palette.text.secondary,
    [theme.breakpoints.up('md')]: {
      fontSize: 14,
    },
    '& a': {
      color: '#83A5B0',
      fontWeight: 'bold',
    },
    '& a:hover': {
      color: darken('#83A5B0', .2),
    }
  }
}));
